<script setup>
import { useRoute } from 'vue-router';

const props = defineProps({
  keepAlive: {
    type: Boolean,
    default: true,
  },
  wide: {
    type: Boolean,
    default: false,
  },
});

const route = useRoute();
</script>

<template>
  <div
    class="flex flex-col w-full h-full m-0 pb-8 pt-4 px-6 overflow-auto bg-n-surface-1"
  >
    <div
      class="flex items-start w-full mx-auto"
      :class="props.wide ? 'max-w-7xl' : 'max-w-5xl'"
    >
      <router-view v-slot="{ Component }">
        <keep-alive v-if="keepAlive">
          <component :is="Component" :key="route.fullPath" />
        </keep-alive>
        <component :is="Component" v-else :key="route.fullPath" />
      </router-view>
    </div>
  </div>
</template>
